import { apiHelper } from '../../common/utils';
import mockHelper from '../../common/mockHelper';
export const productDetail = (params) => {
    let options = {
        url: `/shop/web/shop_item/${params.shopItemId}/shop_item_group_id/${params.shopItemGroupId}`,
        method: 'get'
    }
    let promise;
    if (process.env.REACT_APP_MOCK == 'MOCK2') {
        promise = mockHelper('product_detail')
    } else {
        promise = apiHelper(options)
    }
    return promise;
}


// WEBPACK FOOTER //
// ./src/features/api/productDetail.js